import { VDivider } from 'vuetify/lib/components/VDivider';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VToolbar,{staticClass:"mb-4",attrs:{"flat":"","color":"white"}},[_c(VToolbarTitle,[_vm._v(_vm._s(_vm.$t("heading.settings")))]),_c(VDivider,{staticClass:"mx-2",attrs:{"inset":"","vertical":""}})],1),_c(_vm.components,{tag:"component",attrs:{"settings":_vm.settingsObject}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }